import { axios as client } from './apiAdmin';
import { exportFile } from '../requestDownloadFile';
export default {
  // 获取商家近 30 天的广告活动聚合报表
  getSellerReport: data => {
    return client.get('seller/report/campaign-agg-30d', { params: data }).then(res => res.data);
  },
  getSellerList: data => {
    return client.get('seller/list', { params: data }).then(res => res.data);
  },
  sellerExport: data => {//导出seller
    return exportFile(`seller/export`, data.qs, data.fileName, data.platform);
  },
  sellerReportExport: data => {//导出seller report
    return exportFile(`seller/report/campaign-agg-30d/export`, data.qs, data.fileName, data.platform);
  },
  // 获取商家账单
  getSellerPayments: data => {
    return client.get('seller/billings', { params: data }).then(res => res.data);
  },
  // 获取商家详细信息
  getSellerDetails: data => {
    return client.get('seller/details', { params: data }).then(res => res.data);
  },
  /**
   * 更新商家或publisher信息
   * @param {*} id 
   * @param {*} data 
   * @returns 
   * Seller API: 存彬 http://118.31.23.117:8077/doc.html#/%E8%BF%90%E8%90%A5%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E4%BF%A1%E6%81%AF/updateSellerInfoUsingPUT
   * Publisher API: 存彬 http://118.31.23.117:8077/doc.html#/%E8%BF%90%E8%90%A5%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%8F%91%E5%B8%83%E8%80%85%E4%BF%A1%E6%81%AF/updatePublisherInfoUsingPUT
   */
  updateUserInfo: (id, userType, data) => {
    return client.put(`${userType}/details/${id}`, data);
  },
  // 获取商家佣金配置
  setCommissionConfig: data => {
    return client.post('commission/config', data).then(res => res);
  },
}